module.exports = __webpack_public_path__ + "static/media/xb.1de7b885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xb.png
// module id = 1015
// module chunks = 2